import React, { useState, useEffect } from 'react';

const TypingEffect = ({ text, className, speed = 50, isVisible }) => {
  const [displayedText, setDisplayedText] = useState('');
  const [index, setIndex] = useState(0);

  useEffect(() => {
    if (isVisible && index < text.length) {
      const timeout = setTimeout(() => {
        setDisplayedText((prev) => prev + text[index]);
        setIndex(index + 1);
      }, speed);
      return () => clearTimeout(timeout);
    }
    if (!isVisible) {
      setDisplayedText(''); // Reset text when section is not visible
      setIndex(0);
    }
  }, [index, text, speed, isVisible]);

  return (
    <h2 className={`${className}`}>
      {displayedText}
      <span className="cursor">|</span>
    </h2>
  );
};

export default TypingEffect;

